import { render, staticRenderFns } from "./AuctionLegendDrawer.vue?vue&type=template&id=01d51142&scoped=true&"
import script from "./AuctionLegendDrawer.vue?vue&type=script&lang=js&"
export * from "./AuctionLegendDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AuctionLegendDrawer.vue?vue&type=style&index=0&id=01d51142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d51142",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VIcon,VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
